export const DEFAULT_ITEMS_PER_PAGE = 50;
export const ITEMS_PER_PAGE = 50;
